import { useQuery } from "@tanstack/react-query";
import { useBusyBlockerContext } from "../contexts/busy-blocker-context";
import { useAppContext } from "./useAppContext";
import { useClient } from "./useClient";
import { useDefinition } from "./useDefinition";
import { useSelectedProductAttribute } from "./useSelectedProductAttribute";

export const useOptionsAndAlternatives = () => {
	const definition = useDefinition();

	const client = useClient();

	const { reactQueryNoReloadOptions } = useAppContext();

	const selectedProductAttribute = useSelectedProductAttribute();
	const { busyBlocker } = useBusyBlockerContext();

	return useQuery(
		[
			"options-and-alternatives",
			definition?.product.predefinedName,
			definition?.product.code,
			selectedProductAttribute,
			definition?.product.aspectRatio,
		],
		() =>
			definition
				? busyBlocker.during(
						client.getAlternativesAndOptionsAsync(
							definition.product.predefinedName,
							definition.product.code,
							selectedProductAttribute,
							definition.product.aspectRatio || undefined,
						),
				  )
				: Promise.reject(
						new Error("Cannot fetch options and alternatives without a definition"),
				  ),
		{
			// query will not execute until the definition exists
			enabled: !!definition,
			keepPreviousData: true,
			...reactQueryNoReloadOptions,
		},
	);
};
